import { Button, Select, Typography } from 'antd';
import Input from 'antd/lib/input/Input';
import React, { ReactElement, useContext, useState } from 'react'
import TabHeader from '../../../../components/Tabs/TabHeader';
import { ForestsNearUsContext } from '../../ForestsNearUsContextContainer';
import {
    TableOutlined,
    QuestionOutlined
} from '@ant-design/icons';
import TabPane from '../../../../components/Tabs/TabPane';
import HelpTab from './HelpTab';
import Tabs from '../../../../components/Tabs/Tabs';
import styled from 'styled-components';
import ToolsTab, { ToolsTabIcon } from '../../../../components/Tabs/ToolsTab';
import ShareTab, { ShareTabIcon } from '../../../../components/Tabs/ShareTab';
import { Trans, useTranslation } from 'react-i18next';
const { Option } = Select;

const MinimumSizeContainer = styled.div`
    display: flex;
    padding-top: 1em;
    padding-bottom: 1em;
    align-items: center;

    & label {
        width: 95%;
    }
`;

export default function InfoView() {
    const forestsNearUsContext = useContext(ForestsNearUsContext);
    const [selectedAreaId, setSelectedAreaId] = useState<undefined | string>(undefined);
    const [selectedCommunityId, setSelectedCommunityId] = useState<undefined | string>(undefined);
    const { t } = useTranslation(["nearForests", "sidePanelTabs"], { useSuspense: true });

    var onAreaSelected = async (params: string) => {
        forestsNearUsContext.forestsNearUsStateDispatch({ type: "setIsAreaLoading", isLoading: true });
        forestsNearUsContext.forestsNearUsStateDispatch({ type: 'getArea', id: params });
    }

    var onSaveClicked = async () => {
        if (selectedAreaId) {
            forestsNearUsContext.forestsNearUsStateDispatch({ type: 'saveArea', id: selectedAreaId, communityId: selectedCommunityId });
        }
    }

    var onGetClicked = async () => {
        if (selectedAreaId) {
            forestsNearUsContext.forestsNearUsStateDispatch({ type: "setIsAreaLoading", isLoading: true });
            forestsNearUsContext.forestsNearUsStateDispatch({ type: 'getArea', id: selectedAreaId });
        }
    }

    var onAreaNameInput = (params: string) => {
        setSelectedAreaId(params);
    }

    var onCommunityIdInput = (params: string) => {
        setSelectedCommunityId(params);
    }

    var onDesiredAreaSizeHectaresInput = (params: string) => {
        forestsNearUsContext.forestsNearUsStateDispatch({ type: 'setDesiredAreaSize', size: parseInt(params, 10) });
    }

    var onDesiredAreaSizeMetersInput = (params: string) => {
        forestsNearUsContext.forestsNearUsStateDispatch({ type: 'setDesiredAreaSizeMeters', size: parseInt(params, 10) });
    }

    const tabHeaders: ReactElement[] = [
        <TabHeader step={0} key={0}><TableOutlined /></TabHeader>,
        <TabHeader step={1} key={1}><QuestionOutlined /></TabHeader>,
        <TabHeader step={2} key={2}><ToolsTabIcon /></TabHeader>,
        <TabHeader step={3} key={3}><ShareTabIcon /></TabHeader>
    ];

    return (
        <>
            <Typography.Title level={3}>{t("otsikko")}</Typography.Title>

            <p>
                {t("kuvaus1")}
            </p>

            <p>
                {t("kuvaus2")}
            </p>

            <p>
                <Trans i18nKey="nearForests:kuvaus3"></Trans>
            </p>

            <p>
                {t("kuvaus4")}
            </p>

            <Typography.Title level={5}>{t("valitseAlue")}</Typography.Title>
            <Select
                size="large"
                placeholder={t("sidePanelTabs:valitsePlaceHolder")}
                onFocus={() => window.blur()}
                style={{ "width": "100%" }}
                showSearch
                defaultValue={selectedAreaId}
                loading={forestsNearUsContext.forestsNearUsState.isAreaLoading}
                filterOption={(input, option: any) => option && option.children?.toLowerCase().includes(input.toLowerCase())}
                onSelect={onAreaSelected}
            >
                {
                    forestsNearUsContext.forestsNearUsState.areasForDropDown.map((municipality) => (
                        <Option value={municipality.id} key={municipality.id}>{municipality.namefin}</Option>
                    ))
                }
            </Select>

            {forestsNearUsContext.forestsNearUsState.isAreaLoadInError &&
                <Typography.Title type="danger" level={5}>{t("virheLadatessaAluetta")}</Typography.Title>
            }

            {/* <Input type='text' onChange={(e: any) => onAreaNameInput(e.currentTarget.value)}></Input>
            <Input type='text' onChange={(e: any) => onCommunityIdInput(e.currentTarget.value)}></Input> */}

            {/* <Button onClick={onSaveClicked}>Tallenna</Button> */}
            {/* <Button onClick={onGetClicked}>Hae</Button> */}

            {/* <MinimumSizeContainer>
                <label htmlFor='minimumSizeHectares'>Lähimetsän vähimmäiskoko (hehtaareita)</label>
                <Input style={{ "width": "25%" }} size='middle' id='minimumSizeHectares' type='text' onChange={(e: any) => onDesiredAreaSizeHectaresInput(e.currentTarget.value)}></Input>
            </MinimumSizeContainer> */}

            <MinimumSizeContainer>
                <label htmlFor='minimumSizeMeters'>{t("vähimmäiskoko")}</label>
                <Select
                    id="minimumSizeMeters"
                    size="middle"
                    onFocus={() => window.blur()}
                    style={{ "width": "30%" }}
                    defaultValue={"-1"}
                    onSelect={onDesiredAreaSizeMetersInput}
                >
                    <Option value={"-1"} key={"nolimit"}>{t("vähimmäiskokoEiRajausta")}</Option>
                    <Option value={"60"} key={"60"}>{t("vähimmäiskoko60Metriä")}</Option>
                    <Option value={"120"} key={"120"}>{t("vähimmäiskoko120Metriä")}</Option>
                </Select>
            </MinimumSizeContainer>

            <Tabs tabHeaders={tabHeaders}>
                <TabPane number={0}>
                    <>
                        <Typography.Title level={4}>{t("yhteenvetoOtsikko")}</Typography.Title>

                        {!forestsNearUsContext.forestsNearUsState.selectedAreaToGetId &&
                            <span>{t("valitseEnsinAlue")}</span>}

                        {forestsNearUsContext.forestsNearUsState.isAreaLoading &&
                            <span>{t("latausViesti")}</span>}

                        {!forestsNearUsContext.forestsNearUsState.isAreaLoading &&
                            forestsNearUsContext.forestsNearUsState.selectedAreaToGetId &&
                            forestsNearUsContext.forestsNearUsState.selectedAreaToGetId !== "" && <>
                                <Typography.Title level={5}>{t("metsienPintaAlaYhteensä")}</Typography.Title>
                                <p>
                                    <span> {
                                        forestsNearUsContext.forestsNearUsState.totalForestAreaSize ?
                                            forestsNearUsContext.forestsNearUsState.totalForestAreaSize.toFixed(2) :
                                            0}</span>
                                </p>

                                <Typography.Title level={5}>{t("lähimetsienPintaAlaYhteensä")}</Typography.Title>
                                <p>
                                    <span> {
                                        forestsNearUsContext.forestsNearUsState.nearForestAreaSize ?
                                            forestsNearUsContext.forestsNearUsState.nearForestAreaSize.toFixed(2) :
                                            0}</span>
                                </p>

                                {/* <Typography.Title level={5}>Lähimetsien lukumäärä näkyvällä alueella</Typography.Title>
                                <p>
                                    <span>{forestsNearUsContext.forestsNearUsState.nearForestCount}</span>
                                </p> */}
                            </>}
                    </>
                </TabPane>
                <TabPane number={1}>
                    <HelpTab />
                </TabPane>
                <ToolsTab number={2} showFindForestMask={true} />
                <ShareTab number={3} />
            </Tabs>
        </>
    )
}